// Shared layout for marketing-style pages (docs, changelog, status,
// pricing, security, privacy, terms). The landing uses its own
// composition since it's wider and section-heavy, but these are all
// prose-plus-grids pages that want the same container width + a
// consistent eyebrow + title block up top.
//
//   <MarketingShell eyebrow? title lede? children />
//
// The BigFooter (link columns + wordmark) is rendered inside the page
// body here — not through the shell's Layout component — so it stays
// scoped to marketing pages while the app views (Submit / Analyses /
// Report) keep only the thin status footer.
import type { ReactNode } from "react";
import { BigFooter } from "@/components/shell/BigFooter";

export function MarketingShell({
  eyebrow,
  title,
  lede,
  children,
}: {
  eyebrow?: string;
  title: string;
  lede?: ReactNode;
  children: ReactNode;
}) {
  return (
    <>
      <div className="mx-auto flex min-w-0 max-w-[1080px] flex-col px-5 pt-14 pb-16 sm:px-8 sm:pt-20">
        <header className="min-w-0">
          {eyebrow && <p className="lens-eyebrow">{eyebrow}</p>}
          <h1
            className="mt-3 font-mono text-ink"
            style={{ fontSize: "clamp(32px, 4.5vw, 56px)", lineHeight: 1.02, letterSpacing: "-0.03em" }}
          >
            {title}
          </h1>
          {lede && (
            <p className="mt-5 max-w-[720px] text-ui text-ink-soft" style={{ fontSize: "clamp(16px, 1.3vw, 19px)", lineHeight: 1.55 }}>
              {lede}
            </p>
          )}
        </header>
        <div className="mt-12 min-w-0">{children}</div>
      </div>
      <BigFooter />
    </>
  );
}
